import React, { useState, useRef, useEffect } from 'react';
import './Navbar.css';
import { BellOutlined, UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { useUser } from '../../context/UserContext';
import { useNavigate, useLocation } from 'react-router';
import { useNotification } from '../../context/NotificationContext';

const Navbar = ({ menu }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { user, logout } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const notification = useNotification();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleUserAvatarClick = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = () => {
    logout();
    setDropdownOpen(false);
    notification.success({
      message: 'Logged out successfully',
      placement: 'topRight',
    });
    navigate('/');
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  // Helper function to check if a path is active
  const isActive = (path) => {
    if (path === '/files') {
      return location.pathname === '/files';
    }
    if (path === '/analysis') {
      return location.pathname === '/analysis' || location.pathname.startsWith('/analysis/');
    }
    return location.pathname === path;
  };

  return (
    <div className="navbar-container">
      <div className="navbar-content">
        <div className="navbar-brand">
          <div onClick={() => handleNavigation('/files')} style={{ cursor: 'pointer' }}>
            <img
              src="/golgix-logo-horiz.png"
              alt="golgix"
              height={40}
              className="navbar-logo"
            />
          </div>
        </div>

        <ul className="navbar-menu">
          <li className={`navbar-menu-item ${isActive('/files') ? 'active' : ''}`}>
            <span 
              className={`navbar-menu-link ${isActive('/files') ? 'active' : ''}`}
              onClick={() => handleNavigation('/files')}
              style={{ cursor: 'pointer' }}
            >
              Files
            </span>
          </li>
          <li className={`navbar-menu-item ${isActive('/analysis') ? 'active' : ''}`}>
            <span 
              className={`navbar-menu-link ${isActive('/analysis') ? 'active' : ''}`}
              onClick={() => handleNavigation('/analysis')}
              style={{ cursor: 'pointer' }}
            >
              Analysis
            </span>
          </li>
          {/* TODO: Add notification container */}
          {/* <li className="navbar-menu-item notification-container">
            <BellOutlined />
          </li> */}

          <li className="navbar-menu-item user-avatar-container" ref={dropdownRef}>
            <div className="user-avatar" onClick={handleUserAvatarClick}>
              <UserOutlined />
            </div>
            {dropdownOpen && (
              <div className="user-dropdown">
                <div className="user-dropdown-header">
                  <div className="user-info">
                    <div className="user-name">{user?.name || 'User'}</div>
                    <div className="user-email">{user?.email || 'No email'}</div>
                  </div>
                </div>
                <div className="user-dropdown-divider"></div>
                <div className="user-dropdown-item" onClick={handleLogout}>
                  <LogoutOutlined />
                  <span>Logout</span>
                </div>
              </div>
            )}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
